export default __webpack_public_path__ + "static/media/logo.7453bc2f.svg";